import React from "react";
import { AlertCircle, CheckCircle, RefreshCw } from "lucide-react";

const LoginEmailResult = ({
  result,
  agentNames = {},
  onRetryFailed,
  retrying = false,
  idPrefix = "login-email",
}) => {
  if (!result) return null;
  const failedResults = (result.results || []).filter(
    (item) => item.status !== "sent"
  );
  const partial = result.sent > 0 && result.failed > 0;
  const tone = result.failed === 0 ? "green" : partial ? "amber" : "red";
  const title =
    result.failed === 0
      ? `Sent ${result.sent} login email${result.sent === 1 ? "" : "s"}`
      : partial
      ? `Sent ${result.sent}; ${result.failed} couldn’t be sent`
      : "No login emails were sent";

  const toneClasses = {
    green: "bg-green-50 border-green-200 text-green-800",
    amber: "bg-amber-50 border-amber-200 text-amber-900",
    red: "bg-red-50 border-red-200 text-red-800",
  };

  return (
    <section
      id={`${idPrefix}-result`}
      role={result.failed > 0 ? "alert" : "status"}
      aria-live="polite"
      className={`border rounded-lg p-4 ${toneClasses[tone]}`}
    >
      <h3 className="font-semibold flex items-center">
        {result.failed === 0 ? (
          <CheckCircle className="w-5 h-5 mr-2" aria-hidden="true" />
        ) : (
          <AlertCircle className="w-5 h-5 mr-2" aria-hidden="true" />
        )}
        {title}
      </h3>
      {failedResults.length > 0 && (
        <ul id={`${idPrefix}-failed-list`} className="mt-3 space-y-1 text-sm">
          {failedResults.map((item) => (
            <li key={item.agentId}>
              {agentNames[item.agentId] || "Agent"}: Email could not be delivered.
            </li>
          ))}
        </ul>
      )}
      {failedResults.length > 0 && onRetryFailed && (
        <button
          id={`${idPrefix}-retry-failed`}
          type="button"
          onClick={() => onRetryFailed(failedResults.map((item) => item.agentId))}
          disabled={retrying}
          className="mt-3 min-h-11 inline-flex items-center justify-center rounded-lg border border-current px-4 py-2 text-sm font-semibold hover:bg-white/50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50"
        >
          <RefreshCw
            className={`w-4 h-4 mr-2 ${retrying ? "animate-spin" : ""}`}
            aria-hidden="true"
          />
          Try failed again
        </button>
      )}
    </section>
  );
};

export default LoginEmailResult;
